<template>
  <div
    class="projectstructurebuildingmodelnew"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: [],
    data: () => ({
    }),
  }
</script>
<style>
  .projectstructurebuildingmodelnew {
    width: 100%;
    height: 100%;
  }
</style>
